export default "__VITE_ASSET__l$veSl8e__"